import { Linkable } from '@/components/blocks/Linkable';
import { useMobileHeaderQuery } from '@/components/content/Header';
import { Box } from '@mui/material';

export const DpHeaderTemporalCategory: React.FC<
	React.PropsWithChildren<{
		href: string;
	}>
> = ({ href, children }) => {
	const isMobile = useMobileHeaderQuery();

	if (isMobile) {
		return (
			<Linkable
				href={href}
				sx={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					py: 1,
					justifyContent: 'space-between',
				}}
			>
				<Box
					sx={{
						pb: { xs: 0, md: 2 },
						pt: { xs: 0, md: 2 },
						position: 'relative',
					}}
				>
					<Box
						sx={{
							textDecoration: 'none',
							color: '#2c2c2c !important',
							textTransform: 'uppercase',
							fontSize: '16px',
							fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
							fontWeight: 600,
							position: 'relative',
							whiteSpace: 'nowrap',
							transition: 'color 0.3s ease',
							'@media (max-width: 1333px)': {
								fontSize: '18px !important',
								fontWeight: 900,
							},
						}}
					>
						{children}
					</Box>
				</Box>
			</Linkable>
		);
	}

	return (
		<Box
			sx={{
				zIndex: 1301,
			}}
		>
			<Linkable
				href={href}
				type="button"
				sx={{
					height: '100%',
					minHeight: '66px',
					'&.MuiButton-text': {
						transform: 'none',
						p: { xs: 1.6, lg: 2 },
						backgroundColor: 'transparent',
						color: '#2c2c2c',
						position: 'relative',
						fontSize: { xs: '14px', lg: 'var(--font-size-sm)' },
						borderRadius: 0,
						whiteSpace: 'nowrap',
						'&:first-of-type': {
							ml: -2,
						},
						'&:is(a):not([href])': {
							cursor: 'default',
						},
						textDecoration: 'none',
						'&:after': {
							content: '""',
							position: 'absolute',
							left: 0,
							right: 0,
							bottom: '-1px',
							height: '4px',
							backgroundColor: '#000000',

							display: 'none',
						},
						'&:hover:after': {
							transform: 'scaleX(1)',
							display: 'block',
						},
						'&:not(:hover):after': {
							display: 'none',
						},
					},
				}}
			>
				{children}
			</Linkable>
		</Box>
	);
};
